import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DateFilterComponent } from '../../../shared/date-filter/date-filter.component';

@Component({
  selector: 'app-filter-bill-modal',
  standalone: true,
  imports: [CommonModule, FormsModule, DateFilterComponent],
  templateUrl: './filter-bill-modal.component.html',
})
export class FilterBillModalComponent implements OnInit {
  @Input() currentFilters: {
    text: string;
    startDate: Date | null;
    endDate: Date | null;
    status: string;
  } | null = null;

  @Output() close = new EventEmitter<void>();
  @Output() applyFilters = new EventEmitter<{
    text: string;
    startDate: Date | null;
    endDate: Date | null;
    status: string;
  }>();

  filterText = '';
  selectedStatus = '';
  startDate: Date | null = null;
  endDate: Date | null = null;

  ngOnInit() {
      if( this.currentFilters ){
        this.filterText = this.currentFilters.text;
        this.selectedStatus = this.currentFilters.status;
        this.startDate = this.currentFilters.startDate;
        this.endDate = this.currentFilters.endDate;
      }
  }

  onDateRangeSelected(range: { start: Date | null; end: Date | null }) {
    this.startDate = range.start;
    this.endDate = range.end;
  }


  apply() {
    this.applyFilters.emit({
      text: this.filterText,
      startDate: this.startDate,
      endDate: this.endDate,
      status: this.selectedStatus,
    });
    this.close.emit();
  }
}
